import type { BlockTemplateBase, RelatedProductRenderer } from '@zoomit/editor';
import type { ArrayElement } from '@zoomit/primitives';
import { Box } from '@zoomit/primitives';
import type { ProductListItemDetailsType, ReviewInfoResponseType } from '@zoomit/web-kit';
import { isMobile } from '@zoomit/web-kit';

import RelatedProductSingleItem from './RelatedProductSingleItem';

type Props = {
  template: ArrayElement<BlockTemplateBase['related-product']['subTemplates']>['value'];
  blockData: RelatedProductRenderer;
  reviewData: ReviewInfoResponseType[] | undefined;
};

const RelatedProductSingle = (props: Props) => {
  const { blockData, template, reviewData } = props;

  return (
    <Box spacing={{ mt: isMobile ? 'x3' : 'x4', mb: isMobile ? 'x0' : 'x8' }}>
      {blockData.products.map((productData) => (
        <RelatedProductSingleItem
          key={productData.id}
          template={template}
          productData={productData as ProductListItemDetailsType}
          reviewData={reviewData?.find((d) => d.topicId === productData.id)}
        />
      ))}
    </Box>
  );
};

export default RelatedProductSingle;
